import { Cookies } from "react-cookie";
import { COOKIE_JWT, COOKIE_SAP } from "../common/constant";
import rest from "../common/rest";

export function doLogout() {
  const cookies = new Cookies();
  return () => {
    let cookieConfig = { path: "/", maxAge: 7200 };
    cookies.remove(COOKIE_JWT, cookieConfig);
    cookies.remove(COOKIE_SAP, cookieConfig);
    rest
      .doGet(`/logout`)
      .then(() => {
        redirectToStartpage();
      })
      .catch(() => {
        redirectToStartpage();
      });
  };
}

export function redirectToStartpage() {
  if (typeof window.location.origin === "undefined") {
    window.location.origin = window.location.protocol + "//" + window.location.host;
  }

  window.location.href = window.location.origin;
}
